<template>
    <div :class="{ 'is-read': data.read }">
        <div
            :id="`message-${data.id}`"
            class="richTable-row message-header border-0 p-0"
            data-toggle="collapse"
            :data-target="`#message-${idx}`"
            aria-expanded="false"
            :aria-controls="`message-${idx}`"
            @click="showNews"
            :class="{ hideBody: activeNews !== data.id }"
        >
            <div class="richTable-col message-status" style="--width-md: 5%">
                <a-icon style="width: 24px; height: 24px" icon="Circle" />
            </div>
            <div class="richTable-col" style="--width-md: 95%">
                <h2 class="message-title">{{ data.title }}</h2>
                <p class="mb-0 message-lead" v-html="data.body"></p>
                <button
                    @click.stop="onNotificationRemove"
                    v-if="activeNews === data.id"
                    class="btn btn-outline btn-sm mr-auto "
                    style="color:inherit"
                >
                    <a-icon icon="Close" />Usuń
                </button>
            </div>
            <div class="richTable-col message-actions" style="--width-md: 10%">
                <span>{{ data.publicationDate.slice(0, 11) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showMore: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: true
        }
    },
    computed: {
        activeNews() {
            return this.$store.getters.getActiveNews
        }
    },
    methods: {
        onNotificationRemove() {
            this.$store
                .dispatch('removeSingleNews', this.data.id)
                .then(res => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Powiadomienie zostało usunięte.'
                    })
                })
                .catch(err => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                })
        },
        showNews() {
            const newsId = this.activeNews === this.data.id ? 0 : this.data.id
            this.$store.dispatch('setActiveNews', newsId).then(() => {
                this.$store.dispatch('markOneNewsAsRead', newsId)
            })
        }
    }
}
</script>
